export enum MessageTypeEnum {
  OWN = 'own',
  INCOMING = 'incoming',
}
